<template>
  <div class="Admin">
    <a-form layout="inline">
      <a-form-item label="项目：">
        <a-select
          style="width: 180px"
          show-search
          v-model="dataForm.project_id"
          placeholder="搜索项目"
          :filter-option="false"
          :not-found-content="fetching ? undefined : null"
          @search="handleSearch"
          @change="handleChange"
          :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
        >
          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="d in data" :key="d.id">
            {{ d.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { projectPage } from "@/request/sys";
export default {
  data() {
    this.lastFetchId = 0;
    this.fetchProject = debounce(this.fetchProject, 800);
    return {
      fetching: true,
      data: [],
      dataForm: { project_id: undefined },
    };
  },
  mounted() {
    this.fetchProject("");
  },
  methods: {
    fetchProject(value) {
      console.log("fetching project", value);
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.data = [];
      this.fetching = true;
      projectPage({ name: value }).then((d) => {
        if (fetchId !== this.lastFetchId) {
          return;
        }
        this.data = d.data.list;
        this.fetching = false;
      });
    },
    handleSearch(value) {
      this.fetchProject(value);
    },
    handleChange(value) {
      console.log(value);
      this.$store.commit("setProjectId", value);
    },
  },
};
</script>

<style scoped>
.Admin {
  display: flex;
  margin-right: 20px;
}
</style>